function baseProjectPath(organizationId, projectId) {
  return `/organization/${organizationId}/project/${projectId}`;
}

const organizations = {
  dashboard: organizationId => `/organization/${organizationId}/dashboard`,
  projectList: organizationId => `/organization/${organizationId}/projects`,
  info: organizationId => `/organization/${organizationId}/info`,
  contract: organizationId => `/organization/${organizationId}/contracts`,
  members: organizationId => `/organization/${organizationId}/members`,
  formTemplate: (organizationId, formTemplateId) =>
    `/organization/${organizationId}/form/${formTemplateId}`,
  workspaceList: organizationId => `/organization/${organizationId}/workspaces`,

  templateHome: organizationId => `/organization/${organizationId}/templates`,
  templateList: organizationId => `/organization/${organizationId}/templates/forms`,
  templateModules: organizationId => `/organization/${organizationId}/templates/modules`,
  templateStatus: organizationId => `/organization/${organizationId}/templates/status`,
  templatePriority: organizationId => `/organization/${organizationId}/templates/priority`,
  templateProperties: organizationId => `/organization/${organizationId}/templates/properties`,
  templateObservations: organizationId =>
    `/organization/${organizationId}/templates/common-observations`,
  referentials: organizationId => `/organization/${organizationId}/templates/referentials`,
  groups: organizationId => `/organization/${organizationId}/groups`,
  groupDetail: (organizationId, groupId) => `/organization/${organizationId}/groups/${groupId}`,
  projectsGroups: organizationId => `/organization/${organizationId}/templates/projects-groups`,
  projectsGroupsDetail: (organizationId, groupId) =>
    `/organization/${organizationId}/templates/projects-groups/${groupId}`,
};

const workspaces = {
  dashboard: (organizationId, workspaceId) =>
    `/organization/${organizationId}/workspace/${workspaceId}/dashboard`,
  members: (organizationId, workspaceId) =>
    `/organization/${organizationId}/workspace/${workspaceId}/members`,
  formTemplate: (organizationId, workspaceId, formTemplateId) =>
    `/organization/${organizationId}/workspace/${workspaceId}/form/${formTemplateId}`,
  info: (organizationId, workspaceId) =>
    `/organization/${organizationId}/workspace/${workspaceId}/info`,
  templateHome: (organizationId, workspaceId) =>
    `/organization/${organizationId}/workspace/${workspaceId}/templates`,
  templateList: (organizationId, workspaceId) =>
    `/organization/${organizationId}/workspace/${workspaceId}/templates/forms`,
  templateModules: (organizationId, workspaceId) =>
    `/organization/${organizationId}/workspace/${workspaceId}/templates/modules`,
  templateStatus: (organizationId, workspaceId) =>
    `/organization/${organizationId}/workspace/${workspaceId}/templates/status`,
  templatePriority: (organizationId, workspaceId) =>
    `/organization/${organizationId}/workspace/${workspaceId}/templates/priority`,
  templateProperties: (organizationId, workspaceId) =>
    `/organization/${organizationId}/workspace/${workspaceId}/templates/properties`,
  templateObservations: (organizationId, workspaceId) =>
    `/organization/${organizationId}/workspace/${workspaceId}/templates/common-observations`,
  templateObservationDetail: (organizationId, workspaceId, tradeId) =>
    `/organization/${organizationId}/workspace/${workspaceId}/templates/common-observations/${tradeId}`,
  workspaceGroups: (organizationId, workspaceId) =>
    `/organization/${organizationId}/workspace/${workspaceId}/templates/projects-groups`,
  workspaceGroupsDetail: (organizationId, workspaceId, groupId) =>
    `/organization/${organizationId}/workspace/${workspaceId}/templates/projects-groups/${groupId}`,
};

const deeplink = {
  expired: () => `/invitation/expired`,
};

const general = {
  welcome: '/welcome',
  formTemplate: formTemplateId => `/form/${formTemplateId}`,
};

const home = {
  home: (organizationId, projectId) => `${baseProjectPath(organizationId, projectId)}/home`,
};

const documents = {
  list: (organizationId, projectId) => `${baseProjectPath(organizationId, projectId)}/documents`,
  folderContent: (organizationId, projectId, folderId) =>
    `${baseProjectPath(organizationId, projectId)}/documents/folder/${folderId}`,
  fileContent: (organizationId, projectId, folderId) =>
    `${baseProjectPath(organizationId, projectId)}/documents/file/${folderId}`,
};

const exports = {
  list: (organizationId, projectId) => `${baseProjectPath(organizationId, projectId)}/export`,
};

const groups = {
  list: (organizationId, projectId) => `${baseProjectPath(organizationId, projectId)}/groups`,
};

const userGroups = {
  list: (organizationId, projectId) => `${baseProjectPath(organizationId, projectId)}/user-groups`,
  detail: (organizationId, projectId, groupId) =>
    `${baseProjectPath(organizationId, projectId)}/user-groups/${groupId}`,
};

const plans = {
  root: (organizationId, projectId) => `${baseProjectPath(organizationId, projectId)}/plans`,
  folder: (organizationId, projectId, folderId) =>
    `${baseProjectPath(organizationId, projectId)}/plans/folder/${folderId}`,
  plan: (organizationId, projectId, folderId, planId, planType) =>
    `${baseProjectPath(
      organizationId,
      projectId,
    )}/plans/folder/${folderId}/plan/${planId}/${planType}`,
  bimSplit: (organizationId, projectId, folderId, bimFileId, id) =>
    `${baseProjectPath(
      organizationId,
      projectId,
    )}/plans/folder/${folderId}/plan/${bimFileId}/bim/${id}`,
  bim: (organizationId, projectId, folderId, bimFileId) =>
    `${baseProjectPath(organizationId, projectId)}/plans/folder/${folderId}/plan/${bimFileId}/bim`,
  zone: (organizationId, projectId, folderId, planId) =>
    `${baseProjectPath(organizationId, projectId)}/plans/folder/${folderId}/plan/${planId}/plan`,
  zoning: (organizationId, projectId) =>
    `${baseProjectPath(organizationId, projectId)}/plans/zoning`,
};

const observations = {
  list: (organizationId, projectId, moduleId) =>
    `${baseProjectPath(organizationId, projectId)}/observations/module/${moduleId}`,
  detail: (organizationId, projectId, moduleId, observationId, index) =>
    `${baseProjectPath(
      organizationId,
      projectId,
    )}/observations/module/${moduleId}/observation/${observationId}?index=${index || 0}`,
  categoryList: (organizationId, projectId, moduleId) =>
    `${baseProjectPath(organizationId, projectId)}/observations/module/${moduleId}/categories`,
};

const forms = {
  list: (organizationId, projectId, moduleId) =>
    `${baseProjectPath(organizationId, projectId)}/forms/module/${moduleId}`,
  settings: (organizationId, projectId) =>
    `${baseProjectPath(organizationId, projectId)}/forms-settings`,
  detail: (organizationId, projectId, moduleId, formId, index) =>
    `${baseProjectPath(
      organizationId,
      projectId,
    )}/forms/module/${moduleId}/form/${formId}?index=${index || 0}`,
};

const meetings = {
  list: (organizationId, projectId, moduleId) =>
    `${baseProjectPath(organizationId, projectId)}/meetings/module/${moduleId}`,
  detail: (organizationId, projectId, moduleId, itemId) =>
    `${baseProjectPath(organizationId, projectId)}/meetings/module/${moduleId}/meeting/${itemId}`,
  note: (organizationId, projectId, moduleId, meetingId, sectionId, itemId) =>
    `${baseProjectPath(
      organizationId,
      projectId,
    )}/meetings/module/${moduleId}/note/${itemId}/meeting/${meetingId}/section/${sectionId}`,
};

const members = {
  list: (organizationId, projectId) => `${baseProjectPath(organizationId, projectId)}/members`,
};

const statuses = {
  settings: (organizationId, projectId) => `${baseProjectPath(organizationId, projectId)}/statuses`,
};

const companies = {
  list: (organizationId, projectId) => `${baseProjectPath(organizationId, projectId)}/companies`,
};

const projects = {
  settings: (organizationId, projectId) => `${baseProjectPath(organizationId, projectId)}/settings`,
  dashboard: (organizationId, projectId) =>
    `${baseProjectPath(organizationId, projectId)}/dashboard`,
};

const phases = {
  settings: (organizationId, projectId) => `${baseProjectPath(organizationId, projectId)}/phases`,
};

const tenants = {
  list: (organizationId, projectId) => `${baseProjectPath(organizationId, projectId)}/tenants`,
};

const superAdmin = {
  manageOrganizations: () => `/super-admin/manage-organizations`,
  library: () => '/super-admin/library/priority',
  priority: () => '/super-admin/library/priority',
  status: () => '/super-admin/library/status',
  forms: () => '/super-admin/library/forms',
  tools: () => '/super-admin/tools',
  users: () => '/super-admin/users',
  organizations: () => '/super-admin/organisations',
  projects: () => '/super-admin/projects',
  formsTemplateLibrary: () => '/super-admin/library/forms',
  observations: () => '/super-admin/library/common-observations',
  module: itemId => `/super-admin/library/common-observations/${itemId}`,
};

const httpRedirect = {
  status404: () => '/404',
  status404Project: organizationId => `/organizations/${organizationId}/404`,
};

const payment = {
  checkout: () => `/checkout`,
};

const replaceWorkspaceId = (pathname, workspaceId) => {
  const pathSegments = pathname.split('/');
  const workspaceIndex = pathSegments.indexOf('workspace');

  if (workspaceIndex === -1) {
    pathSegments.splice(3, 0, 'workspace', workspaceId);
    const pageName = pathSegments[pathSegments.length - 1];
    if (pageName === 'contracts' || pageName === 'workspaces') {
      pathSegments[pathSegments.length - 1] = 'info';
    }
  } else {
    pathSegments[workspaceIndex + 1] = workspaceId;
  }
  return pathSegments.join('/');
};

export const Routing = {
  workspaces,
  organizations,
  deeplink,
  general,
  home,
  documents,
  exports,
  groups,
  plans,
  observations,
  forms,
  meetings,
  members,
  companies,
  projects,
  phases,
  superAdmin,
  httpRedirect,
  statuses,
  payment,
  replaceWorkspaceId,
  userGroups,
  tenants,
};
